import { syncraApi, syncraApiAdapter } from '@/api/main/syncraClient'
import { TraderReferralSummaryPayload, PaymentTypeEnum6 } from 'syncra-api-client'
import { DateRange } from 'react-day-picker'
import { isToday } from 'date-fns'
import { normalizeDateRange } from '@/shared/lib/date'

interface UseReferralSummaryParams {
  dateRange?: DateRange | undefined
  paymentType?: PaymentTypeEnum6
}

interface UseReferralSummaryReturn {
  data: TraderReferralSummaryPayload | undefined
  isLoading: boolean
  error: any
  refetch: (options?: any) => Promise<any>
  totalEarnings: number
  isCurrentDate: boolean
  yesterdayBalancePayIn: number
}

export const useReferralSummary = ({
  dateRange,
  paymentType = PaymentTypeEnum6.Value1
}: UseReferralSummaryParams = {}): UseReferralSummaryReturn => {
  // Нормализуем даты для API запроса
  const { startDate, endDate } = normalizeDateRange(dateRange)

  const { data, isLoading, error, refetch } = syncraApiAdapter.createQueryHook<TraderReferralSummaryPayload>(
    ['referral-summary', startDate, endDate, paymentType],
    () => syncraApi.v1.traderReferralsSummaryList({
      paymentType,
      startDate,
      endDate,
    })
  )()

  // Проверяем, является ли выбранная дата сегодняшней
  const isCurrentDate = dateRange?.to ? isToday(dateRange.to) : false
  
  // Получаем вчерашний баланс из API
  const yesterdayBalancePayIn = data?.yesterdayReferralTopupSummary?.totalAmountTo || 0

  return {
    data,
    isLoading,
    error,
    refetch,
    totalEarnings: data?.totalReferralProfit ?? 0,
    isCurrentDate,
    yesterdayBalancePayIn,
  }
}
